import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';

import { RouterStateSerializer } from '@ngrx/router-store';

import { RouterStateUrl } from '../ngrx/core-reducers';

@Injectable()
export class CustomRouterStateSerializer
  implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;
    let params = null;
    let data = null;

    while (route.firstChild) {

      route = route.firstChild;
      params = { ...params, ...route.params };
      data = { ...data, ...route.data };
    }

    const { url, root: { queryParams } } = routerState;

    return { url, params, queryParams, data };
  }
}
